/* Component to display the adv Crew info */
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";
import btnStyles from "../../styles/Button.module.css";
import { useHistory } from "react-router-dom";
import TopBox from "../../components/TopBox";
import ReplaceInfo from "./ReplaceInfo";
import RotateInfo from "./RotateInfo";
import PermissionsInfo from "./PermissionsInfo";
import CrewInfoManage from "./CrewInfoManage";
import CastInfoManage from "./CastInfoManage";
import CastDeleteRep from "./CastDeleteRep";

const InfoAll = () => {
  const [showCrew, setShowCrew] = useState(false);
  const [showCast, setShowCast] = useState(false);
  const [showPer, setShowPer] = useState(false);
  const [showCastDel, setShowCastDel] = useState(false);
  const [showRep, setShowRep] = useState(false);
  const [showRot, setShowRot] = useState(false);
  const history = useHistory();

  return (
    <div className="mb-5">
      <TopBox work="manage Users" title="Manage Crew and Cast Info" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} py-0 mt-1`}
        onClick={() => history.goBack()}
      >
        Back
    </Button>
    <div >
    <Row>
    <Col xs={12}>
    <div className= {`my-3 ${styles.White}`}>
    <h5 className={`text-center py-1 ${styles.SubTitle }`}>
        REGISTER & MANAGE CREW AND CAST INFO PAGES</h5>
    {/* manage crew style={{fontStyle: 'italic'}} md={{span: 8, offset: 2}}*/}
    <div className="mb-3" >
    <Row>
    <Col xs={{span: 6, order: 2}} md={{span: 4, order: 1}} className="text-center" >
    <Button
    className={` py-0 px-3 px-md-5 mt-3 ${btnStyles.Order} ${btnStyles.Button}`}
    onClick={() => setShowCrew(showCrew => !showCrew)} >
      MANAGE CREW
    </Button>
    </Col>
    <Col xs={{span: 12, order: 1}} md={{span: 4, order: 2}} className="text-center">
    <Button
    className={`mt-3 py-0 px-3 px-md-5 ${btnStyles.Order} ${btnStyles.Button}`}
    onClick={() => setShowPer(showPer => !showPer)} >
     PERMISSIONS
    </Button>
    </Col>
    <Col xs={{span: 6, order: 12}} md={{span: 4, order: 3}} className="text-center">
    <Button
    className={`mt-3 py-0 px-3 px-md-5 ${btnStyles.Order} ${btnStyles.Button}`}
    onClick={() => setShowCast(showCast => !showCast)} >
     MANAGE CAST
    </Button>
    </Col>
    </Row>
    </div>
    <Row>
    <Col xs={{span: 8, offset: 2}} >
    <hr/>
    </Col>
    </Row>
    {/* replace xs={{span: 6, order: 12}} md={{span: 4, order: 3}}*/}
    <Row>
    <Col xs={12} md={4} className="text-center">
    <Button
    className={`py-0 mt-3 ${btnStyles.GreyDark} ${btnStyles.Button}`}
    onClick={() => setShowRot(showRot => !showRot)} >
      Rotating Crew/Directors
    </Button>
    </Col>
    <Col xs={6} md={4} className="text-center" >
    <Button
    className={`py-0 mt-3 ${btnStyles.GreyDark} ${btnStyles.Button}`}
    onClick={() => setShowRep(showRep => !showRep)} >
      Replacing/Removing Crew
    </Button>
    </Col>
    <Col xs={6} md={4} className="text-center" >
    <Button
    className={`py-0 mt-3 ${btnStyles.GreyDark} ${btnStyles.Button}`}
    onClick={() => setShowCastDel(showCastDel => !showCastDel)} >
      Replacing/Removing Cast
    </Button>
    </Col>
    </Row>
    </div>
    </Col>
    </Row>
    </div>
    <div>
    </div>
    {!showPer ? (
          ""
              ) : (
                <PermissionsInfo  /> 
      ) }
      {!showCrew ? (
          ""
              ) : (
                <CrewInfoManage  /> 
      ) }
      {!showCast ? (
          ""
              ) : (
                <CastInfoManage  /> 
      ) }
      {!showRot ? (
          ""
              ) : (
                <RotateInfo  /> 
      ) } 
    {!showRep ? (
          ""
              ) : (
                <ReplaceInfo  /> 
      ) }
      {!showCastDel ? (
          ""
              ) : (
                <CastDeleteRep  /> 
      ) }  
    </div>
  );
};

export default InfoAll